<sirius-container data-cy="navigation-menu-simple-container">
    @if (logo) {
        <a class="sir-logo-container" [href]="$safeNavigationMigration(logo.link?.href)" [title]="$safeNavigationMigration(logo.link?.title)">
            <img
                class="sir-logo"
                [src]="logo.url"
                alt="Universal Robots"
                fetchpriority="high"
                data-cy="nav-simple-logo" />
        </a>
    }
    <div class="sir-text-container" data-cy="navigation-menu-simple-text-container">
        @if (text) {
            <p class="sir-text">
                {{ text }}
                @if (link) {
                    <a
                        siriusButton
                        [href]="link.href"
                        [title]="link.title"
                        [rel]="link.rel"
                        [buttonText]="link.title"
                        [buttonType]="'linkstyle'"></a>
                }
            </p>
        }
    </div>
</sirius-container>
